import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-remotedb-type-service',
    templateUrl: './remotedb-type-service.component.html',
    styleUrls: ['./remotedb-type-service.component.scss'],
    standalone: false
})
export class RemotedbTypeServiceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
